import { startOfDay, addDays, min } from 'date-fns'

import { type InventoryItem } from '../../../helpers'

import { AD_INVENTORY } from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

interface Right {
  start_date: string
  end_date: string
  [AD_INVENTORY]: InventoryItem[]
  [key: string]: any
}

interface UseTimelineDataReturn {
  timelineStartDate: Date | string | null
  timelineEndDate: Date | string | null
}

const getInventoryAvailabilityTimelineData = (right: Right): UseTimelineDataReturn => {
  // Use right dates as timeline boundaries - normalize to midnight to avoid timezone issues
  const rightStartDate = startOfDay(new Date(right.start_date))
  const rightEndDate = startOfDay(new Date(right.end_date))

  // define timelineStartDate conditionally if rightStartDate is in the past, use today
  const timelineStartDate = rightStartDate < startOfDay(new Date()) ? startOfDay(new Date()) : rightStartDate
  // Limit timeline to maximum 180 days from start date
  const maxEndDate = addDays(timelineStartDate, 180)
  const timelineEndDate = min([rightEndDate, maxEndDate])

  return {
    timelineStartDate,
    timelineEndDate
  }
}

export default getInventoryAvailabilityTimelineData
